import { useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { User, BookOpen, Sparkles, Timer } from "lucide-react";
import InfosPerso from "@/pages/shared/espace/InfosPerso";
import Documentation from "@/pages/shared/espace/Documentation";
import CantumHoraire from "@/pages/shared/espace/CantumHoraire";

const TABS = ["infos", "documentation", "horaire", "fiche"];

function FicheSoon() {
  return (
    <div className="ek-card p-10 text-center space-y-3" data-testid="fiche-coming-soon">
      <div className="w-14 h-14 mx-auto rounded-2xl bg-[#FFF7D6] grid place-items-center">
        <Sparkles className="w-7 h-7 text-[#B38F00]" />
      </div>
      <span className="inline-block text-xs font-bold uppercase tracking-wider bg-[#E6B800] text-[#1A2E28] px-3 py-1 rounded-full">Bientôt</span>
      <h2 className="text-xl font-bold" style={{ fontFamily: "Outfit" }}>Génération de fiches pédagogiques</h2>
      <p className="text-sm text-[#5C736A] max-w-md mx-auto">
        Bientôt, vous pourrez générer automatiquement vos fiches de préparation (leçons, objectifs, déroulement) grâce à l&apos;intelligence artificielle.
      </p>
    </div>
  );
}

export default function EspaceEnseignants() {
  const [params, setParams] = useSearchParams();
  const tab = TABS.includes(params.get("tab")) ? params.get("tab") : "infos";
  const change = (v) => setParams({ tab: v }, { replace: true });

  return (
    <div className="space-y-5" data-testid="espace-enseignants-page">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold" style={{ fontFamily: "Outfit" }}>Espace enseignants</h1>
        <p className="text-sm text-[#5C736A]">Vos informations, la documentation de l&apos;école et le suivi de vos heures.</p>
      </div>
      <Tabs value={tab} onValueChange={change}>
        <TabsList className="w-full overflow-x-auto flex justify-start">
          <TabsTrigger value="infos" data-testid="espace-tab-infos"><User className="w-4 h-4 mr-1" /> Infos perso</TabsTrigger>
          <TabsTrigger value="documentation" data-testid="espace-tab-documentation"><BookOpen className="w-4 h-4 mr-1" /> Documentation</TabsTrigger>
          <TabsTrigger value="horaire" data-testid="espace-tab-horaire"><Timer className="w-4 h-4 mr-1" /> Quantum horaire</TabsTrigger>
          <TabsTrigger value="fiche" data-testid="espace-tab-fiche"><Sparkles className="w-4 h-4 mr-1" /> Génération de fiche</TabsTrigger>
        </TabsList>
        <TabsContent value="infos" className="mt-5"><InfosPerso /></TabsContent>
        <TabsContent value="documentation" className="mt-5"><Documentation /></TabsContent>
        <TabsContent value="horaire" className="mt-5"><CantumHoraire /></TabsContent>
        <TabsContent value="fiche" className="mt-5"><FicheSoon /></TabsContent>
      </Tabs>
    </div>
  );
}
